import styled from "styled-components"

import Spacing from "@irati/ui/src/Spacing"
import BaseLink from "@irati/ui/src/Link"

interface ColorProp {
  color?: string
}

export const BackgroundColor = styled(Spacing)<ColorProp>`
  background-color: ${({theme, color}) => color || theme.colors.greys.white};
`

export const Image = styled.img<ColorProp>`
  background-color: ${({theme, color}) => color || theme.colors.greys.white};
  display: block;
  margin: 0 auto;
`

export const Link = styled(BaseLink)`
  cursor: pointer;
`
